import { toast } from 'react-hot-toast';
import { useState, useEffect } from 'react';
import SuccessALertSvg from '../svgFiles/SuccessALertSvg';
import ErrorALertSvg from '../svgFiles/ErrorALertSvg';
import { CloseTostSvg } from '../svgFiles/CloseTostSvg';
import {
  formatDashboardDateLong,
  formatDashboardDateShort,
} from './dashboardTime';
export const isNullOrEmpty = (data) => {
  return (
    data === null ||
    data === undefined ||
    data === '' ||
    (Array.isArray(data) && data.length === 0) ||
    (typeof data === 'object' && Object?.keys(data).length === 0)
  );
};


export const capitalize = (str) => {
  if (!str) return str; // Handle null or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const iconMap = {
  success: <SuccessALertSvg />,
  error: <ErrorALertSvg />,
  info: <SuccessALertSvg />,
  loading: <SuccessALertSvg />,
};
const allowedTypes = ["success", "error", "info", "loading"];

export const showToast = (message = "", type = "info", options = {}) => {
  if (!message) return;

  const toastType = allowedTypes.includes(type) ? type : "info";

  // 🔹 Map classes by type
  const classMap = {
    success: "toast-success",
    error: "toast-error",
    info: "toast-info",
    loading: "toast-loading",
  };

  // 🔹 Dynamic timeout by type (can be tuned)
  const durationMap = {
    success: 2000,
    error: 3000,
    info: 3000,
    loading: Infinity, // stays until dismissed
  };

  // 🔹 Use custom render so we can add close button
  toast.custom(
    (t) => (
      <div
        className={`toastWrapper d-flex align-items-center justify-between gap-2 p-3 rounded-lg shadow-md ${classMap[toastType] || "toast-default"
          } ${t.visible ? "animate-enter" : "animate-leave"}`}
      >
        {iconMap[toastType] && <span>{iconMap[toastType]}</span>}
        <span className="text-sm">{message}</span>
        <CloseTostSvg onClick={() => {
          t.visible = false;
          toast.remove(t.id);
        }} />
      </div>
    ),
    {
      id: options.id || message, // fallback to message if no custom id
      duration:
        options.duration !== undefined
          ? options.duration
          : durationMap[toastType] || 3000,
      position: options.position || "bottom-center",
      ...options,
    }
  );
};

export function serialize(obj) {
  let str = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      if (Array.isArray(obj[p])) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p].join(',')));
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
  }
  return str.join("&");
}

export const createOptionListForSelectTag = (data = null, label = "", value = "", suffix = "", overrideLabel = "") => {
  let list = [];

  if (isNullOrEmpty(data) || isNullOrEmpty(label) || isNullOrEmpty(value)) {
    return list;
  }

  if (!Array.isArray(data)) {
    return list;
  }

  list = data?.map(cur => {
    const labelText =
      (isNullOrEmpty(overrideLabel) || isNullOrEmpty(cur[overrideLabel]))
        ? cur[label]
        : cur[overrideLabel];

    return {
      value: cur[value],
      label: labelText + (isNullOrEmpty(suffix) ? "" : " (" + cur[suffix] + ")"),
    };
  });

  return list;
};


export const validatePassword = (password, confirmPassword) => {
  const regexForUppercase = new RegExp("(?=.*[A-Z])");
  const regexForLowercase = new RegExp("(?=.*[a-z])");
  const regexForNum = new RegExp(/\d/);
  const regexForSpecialChar = new RegExp("(?=.*\\W)");
  const regexForLength = new RegExp(/^.{12,50}$/);

  let error = {
    isValidSubmission: false,
  };

  if (!regexForUppercase.test(password)) {
    error.uppercaseChar = "Must contain at least one uppercase letter (A - Z)";
  } else {
    error.uppercaseCheck = "true";
  }

  if (!regexForLowercase.test(password)) {
    error.lowercaseChar = "Must contain at least one lowercase letter (a - z)";
  } else {
    error.lowercaseCheck = "true";
  }

  if (!regexForNum.test(password)) {
    error.number = "Must contain at least one number (0 - 9)";
  } else {
    error.numberCheck = "true";
  }

  if (!regexForSpecialChar.test(password)) {
    error.specialChar = "Must contain at least one special character (e.g. !, #, $, %)";
  } else {
    error.specialCharCheck = "true";
  }

  if (!regexForLength.test(password)) {
    error.length = "Must contain between 12 and 50 characters";
  } else {
    error.lengthCheck = "true";
  }

  if (password !== confirmPassword && confirmPassword !== null && confirmPassword !== "") {
    error.match = "Password and Confirm Password don't match!";
  } else {
    error.match = "";
  }

  error.isValidSubmission =
    regexForUppercase.test(password) &&
    regexForLowercase.test(password) &&
    regexForNum.test(password) &&
    regexForSpecialChar.test(password) &&
    regexForLength.test(password);

  if (error.isValidSubmission) {
    delete error.uppercaseChar;
    delete error.lowercaseChar;
    delete error.number;
    delete error.specialChar;
    delete error.length;
  }

  return error;
};
export const getClassByType = (type) => {
  const classMap = {
    0: { class: "class-missingRx", title: "Missing Rx" },
    1: { class: "class-unfilled", title: "Unfilled Rx" },
    2: { class: "class-readyMake", title: "Ready to make" },
    3: { class: "class-lensSent", title: "Lenses sent" },
    4: { class: "class-readyAssemble", title: "Ready to assemble" },
    5: { class: "class-readyShip", title: "Ready to ship" },
    6: { class: "class-shipped", title: "Shipped" },
    7: { class: "class-shipped", title: "Delivered" },
    8: { class: "class-shipped", title: "Fulfilled" },
    999: { class: "class-cancelled", title: "Cancelled" },
  };

  return classMap[type] || { class: "default-class", title: "Unknown" };
};
export const formatDateToMDY = (dateString) => {
  // Always Pacific — DB timestamps stay UTC.
  return formatDashboardDateShort(dateString, "");
};

export const formatTimeTo12Hour = (timeString) => {
  if (!timeString) return '';

  const [hourStr, minuteStr] = timeString.split(':');
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  const period = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12; // convert 0 -> 12

  return `${hour}:${minute.toString().padStart(2, '0')} ${period}`;
};


export const formatDate = (dateString) => {
  // Always Pacific — DB timestamps stay UTC.
  return formatDashboardDateLong(dateString, "");
};


export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(handler)
  }, [value, delay])
  return debouncedValue
}


export function formatPrescriptionValue(value, type) {
  if (value == null || value === "") return "";

  const num = parseFloat(String(value).replace(/,/g, ""));
  if (isNaN(num)) return String(value);

  let str;

  switch (type) {
    case "SPH":
    case "CYL":
    case "ADD":
    case "PD":
      // Always show 2 decimals
      str = num.toFixed(2);
      break;

    case "AXIS":
      // Whole numbers only (1–180)
      str = Math.round(num).toString();
      break;

    default:
      // fallback
      str = num.toString();
  }

  // Add "+" for positive numbers in SPH, CYL, ADD
  if (["SPH", "CYL", "ADD"].includes(type) && num > 0 && !str.startsWith("+")) {
    str = "+" + str;
  }

  return str;
}
export const glassTypeLabels = {
  F: "Full set",
  G: "Glasses only",
  L: "Lenses only",
  S: "Sunglasses only",
  C: "Charging cable",
};

export const downloadFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const getGlassTypeOptions = ({ productType, skuName }) => {
  const sku = skuName?.toLowerCase() || "";

  const ALL_GLASS_TYPES = {
    F: { label: "Full set", value: "F" },
    L: { label: "Lenses only", value: "L" },
    G: { label: "Glasses only", value: "G" },
    S: { label: "Sunglasses only", value: "S" },
    C: { label: "Charging cable", value: "C" },
  };

  // productType should be the source of truth for what user selected.
  // SKU text often contains words like "sunglass" even for clip-ons / frame configs,
  // so we don't want it to override the explicit productType.
  if (productType === "lens") {
    return [ALL_GLASS_TYPES.F, ALL_GLASS_TYPES.L];
  }

  if (productType === "frame") {
    return [ALL_GLASS_TYPES.F, ALL_GLASS_TYPES.G];
  }

  if (productType === "other" || productType === "unknown") {
    // Sunglasses / accessories / services collapse to "other" in GET APIs.
    if (sku.includes("sunglass")) {
      return [ALL_GLASS_TYPES.S];
    }
    if (sku.includes("charging")) {
      return [ALL_GLASS_TYPES.C];
    }
    return [ALL_GLASS_TYPES.C, ALL_GLASS_TYPES.S];
  }

  if (productType === "sunglasses") {
    return [ALL_GLASS_TYPES.S];
  }

  if (productType === "accessories") {
    // Default to charging cable for accessory productType; fallback to SKU parsing below.
    return [ALL_GLASS_TYPES.C];
  }

  if (productType === "services") {
    return [ALL_GLASS_TYPES.C];
  }

  // Fallback to SKU parsing when productType isn't one of the known values.
  if (sku.includes("sunglass")) {
    return [ALL_GLASS_TYPES.S];
  }

  if (sku.includes("charging")) {
    return [ALL_GLASS_TYPES.C];
  }

  // fallback
  return [ALL_GLASS_TYPES.F];
};